import { CategoryDTO, CategoryEntity } from '@gearbelt/global';
import { v4 as uuidv4 } from 'uuid';

import { UpdateWorkspaceEntityDialog, type UpdateWorkspaceEntityDialogConfig } from '@/components/settings/update-workspace-entity-dialog';

const categoryConfig: UpdateWorkspaceEntityDialogConfig<CategoryDTO> = {
  title: 'Document Categories',
  description: 'These allow you to group documents under custom categories. You can edit, remove, and add new categories. All categories are editable at once.',
  createEmptyItem: () => ({
    id: uuidv4(),
    name: '',
    entity: CategoryEntity.Document,
    order: null,
  }),
  getValue: (item) => item.name,
  setValue: (item, value) => ({ ...item, name: value }),
  isDeletable: (item) => item.deletable !== false,
  nonDeletableTooltip: (item) =>
    item.nonDeletableReason === 'system'
      ? "This is a required category and can't be deleted"
      : item.nonDeletableReason === 'hasNotificationRule'
        ? "This category has a notification rule set up and can't be deleted"
        : "Categories with assigned documents can't be deleted",
};

function UpdateWorkspaceDocumentCategories({
  documentCategories,
  open,
  onOpenChange,
  callback,
}: {
  documentCategories: CategoryDTO[] | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (categories: CategoryDTO[]) => void;
}) {
  return <UpdateWorkspaceEntityDialog items={documentCategories} open={open} onOpenChange={onOpenChange} callback={callback} config={categoryConfig} />;
}

export { UpdateWorkspaceDocumentCategories };
